import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import Seo from '@/components/Seo';

export default function OrderCancelled() {
  return (
    <div className="section-light min-h-screen bg-[var(--mw-bg)] text-white flex flex-col">
      <Seo title="Payment Cancelled" path="/order/cancelled" noindex />
      <header className="border-b border-white/10 px-6 py-5">
        <Link to="/" className="text-[10px] uppercase tracking-[0.32em] text-white/60 hover:text-white">
          ← Back to shop
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div data-testid="order-cancelled" className="max-w-md w-full text-center">
          <div className="mx-auto w-20 h-20 rounded-full bg-[var(--mw-primary)]/15 border border-[var(--mw-primary)]/40 flex items-center justify-center mb-8">
            <XCircle size={36} className="text-[var(--mw-primary)]" />
          </div>
          <div className="text-[11px] uppercase tracking-[0.32em] text-white/55 mb-3">Payment cancelled</div>
          <h1 className="font-display font-light text-4xl sm:text-5xl leading-tight tracking-tight mb-4">
            Your cart is safe.
          </h1>
          <p className="text-white/60 leading-relaxed mb-8">
            No charge was made. Your items are still in your cart — you can review and check out again anytime.
          </p>
          <Link
            to="/"
            data-testid="order-cancelled-return"
            className="inline-flex text-[11px] uppercase tracking-[0.22em] bg-[var(--mw-primary)] hover:bg-[var(--mw-primary-hover)] text-white px-6 py-3.5 transition-colors"
          >
            Return to shop
          </Link>
        </div>
      </main>
    </div>
  );
}
